import { z } from 'zod';

/** Systèmes de design disponibles pour l'interface (choisis dans l'espace /superadmin). */
export const DESIGN_SYSTEMS = ['default', 'fluent', 'polaris'] as const;
export type DesignSystem = (typeof DESIGN_SYSTEMS)[number];
export const DEFAULT_DESIGN_SYSTEM: DesignSystem = 'default';

export const DESIGN_SYSTEM_CATALOG: Record<DesignSystem, { label: string; description: string }> = {
  default: { label: 'Dendromap', description: 'Le style actuel : vert forêt, coins arrondis, ombres douces.' },
  fluent: {
    label: 'Microsoft Fluent',
    description: 'Style Microsoft 365 : police Segoe UI, boutons nets et tableaux en grille comme Excel, avec les couleurs de Dendromap.',
  },
  polaris: {
    label: 'Shopify Polaris',
    description: 'Style Shopify : police Inter, boutons à léger relief, cartes à liseré fin et tableaux sobres, avec les couleurs de Dendromap.',
  },
};

export const DesignSystemSchema = z.enum(DESIGN_SYSTEMS);
export const DesignSystemUpdateSchema = z.object({ design_system: DesignSystemSchema });

/** Valeur stockée ou reçue → système connu (retombe sur le style par défaut). */
export function resolveDesignSystem(value: unknown): DesignSystem {
  const parsed = DesignSystemSchema.safeParse(value);
  return parsed.success ? parsed.data : DEFAULT_DESIGN_SYSTEM;
}
